import { floor, isNumber } from "lodash";

const almostZero = 0.001;

export const isSignificantlyGreaterThan = (lhs: number, rhs: number, $epsilon = almostZero) => {
    return lhs - rhs > $epsilon;
};

export const almostEquals = (lhs: number, rhs: number, $epsilon = almostZero) => {
    return Math.abs(lhs - rhs) < $epsilon;
};

/**
 * Returns Calculated Percentage with precision
 */
export const calculatePercentage = (value: number, total: number, precision?: number) => {
    if (total === 0 || value === 0) {
        return 0;
    }

    return floor((value / total) * 100, precision ?? 2);
};

export const leftShiftByTwo = (value: number | string) => {
    const number = isNumber(value) ? value : Number.parseFloat(value);
    return Math.round(number * 100 * 10 ** 5) / 10 ** 5;
};

export const extractNumericPart = (inputString: string) => {
    const numericPart = /[-+]?\d*\.?\d+/.exec(inputString);

    return numericPart ? Number.parseFloat(numericPart[0]) : null;
};

interface isInRangeProps {
    value: number;
    min: number;
    max: number;
    includeLimitValues?: boolean;
}

/**
 * Checks if value is particular range.
 * Added instead of lodash inRange since it does not include upper value (uses < instead of <= for max)
 * https://github.com/lodash/lodash/issues/3147
 */
export const isInRange = ({ value, min, max, includeLimitValues = true }: isInRangeProps) => {
    return includeLimitValues ? value >= min && value <= max : value > min && value < max;
};
